module.exports = __webpack_public_path__ + "img/IMG_1515.4f0667f0.jpg";